/**
 * * Отве при запросе на получение пути к задачи
 */
export class GetRouteResponseModel {
  /**
   * * Айди раюочей области
   */
  NamespaceId!: string;
  /**
   * * Айди очереди задач
   */
  QueueTaskId!: string;
  /**
   * * Айди проекта
   */
  ProjectId!: number;
  constructor(obj?: Partial<GetRouteResponseModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
